import { useEffect, Component } from "react";
import Lenis from "lenis";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Exploration from "./components/Exploration";
import ShowcaseBand from "./components/ShowcaseBand";
import ClosingCTA from "./components/ClosingCTA";
import Logo from "./components/Logo";

class ErrorBoundary extends Component {
    state = { failed: false };
    static getDerivedStateFromError() {
        return { failed: true };
    }
    render() {
        if (this.state.failed) {
            return (
                <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-ink">
                    <Logo />
                    <p className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">
                        Something glitched in the void — refresh to retry
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="noise-overlay min-h-screen bg-ink font-sans text-slate-100">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Exploration />
                <ShowcaseBand />
                <ClosingCTA />
            </main>
        </div>
    );
}

export default function RootApp() {
    return (
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    );
}
